module.exports = __webpack_public_path__ + "img/title-list.3b62904f.svg";